import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';

export interface ImagePathTagFormValues {
  image_path: string;
  tag: string;
}

export const imagePathTagDefaultValues: ImagePathTagFormValues = {
  image_path: '',
  tag: ''
};

export const imagePathTagSchema = yup.object({
  image_path: yup
    .string()
    .required('Image Path is required')
    .min(1, 'Image Path is required'),
  tag: yup
    .string()
    .required('Tag is required')
    .min(1, 'Tag is required')
});

export function useImagePathTagForm(initialValues?: any) {
  return useForm({
    values: initialValues || imagePathTagDefaultValues,
    mode: 'onSubmit',
    resolver: yupResolver(imagePathTagSchema),
    defaultValues: { ...imagePathTagDefaultValues, ...initialValues },
  });
}
